import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./Styles/index.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./App/store";
import { ToastContainer } from "react-toastify";
import "./Styles/Toast.css";
import { APP_BASENAME } from "./lib/basePath";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Router basename={APP_BASENAME || undefined}>
      <App />
    </Router>
    <ToastContainer
      position="top-center"
      autoClose={2000}
      pauseOnHover={false}
      pauseOnFocusLoss={false}
    />
  </Provider>
);

reportWebVitals();
